/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import React from 'react';
import { Button } from 'devextreme-react/button';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
/* NPM Imports End */

/* Project Imports Start */
import serviceCall from '../../../store/serviceCall';
import { ToasterMessage } from '../../sharedComponents/';
import { responseOkCode, somethingwentWrong } from '../../../constant';

/* Project Imports End */

/* CCS & Image imports Start */
import './exportToExcel.scss';
/* CCS & Image imports End */

const exportReport = () => {
  serviceCall.getAllReports('Reports/GetReports').then(response => {
    if (response.status === responseOkCode) {
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';
      const ws = utils.json_to_sheet(response.data.d.results);
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
      const excelBuffer = write(wb, {
        bookType: 'xlsx',
        type: 'array',
      });
      const data = new Blob([excelBuffer], { type: fileType });
      saveAs(data, 'test' + fileExtension);
      ToasterMessage('success', 'File exported successfully');
    } else {
      ToasterMessage('error', somethingwentWrong);
    }
  });
};

export const ExportToExcel = () => (
  <Button
    text={`Export`}
    onClick={() => exportReport()}
    className="btnReport"
    type={'normal'}
  />
);

ExportToExcel.displayName = 'ExportToExcel';

/* PropsTypes Validation Start*/
ExportToExcel.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
};
/* PropsTypes Validation End*/

/* DefaultProps */
ExportToExcel.defaultProps = {
  text: 'Sample Toaster Message',
  type: 'success',
};
/* DefaultProps */
